import './dropdown.scss';
import { Popover, Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import React, { useEffect, useState } from 'react';
import Arrow from '@svg/chevron-down_20.svg?react';
import CustomIcon, { IconType } from '../../custom-icon/custom-icon';

const {Option} = Select;

interface DropdownProps {
    accessor: string;
    value?: any;
    options: { value: string; label: string }[];
    editProp: (accessor: string, value: any) => void;
    placeholder?: string;
    selectProps?: SelectProps;
    infoContent?: (id: string) => React.ReactNode
}

export const Dropdown = ({
                             accessor,
                             value,
                             options,
                             editProp,
                             placeholder,
                             selectProps,
                             infoContent
                         }: DropdownProps) => {

    const [popoverVisible, setPopoverVisible] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const handleDropdownVisibleChange = (open: boolean) => {
        setPopoverVisible(open && !!selectProps?.maxTagCount && !!value?.length);
        setIsDropdownOpen(open);
    };

    useEffect(() => {
        setPopoverVisible(isDropdownOpen && !!selectProps?.maxTagCount && !!value?.length);
    }, [value?.length, selectProps?.maxTagCount]);

    const renderOption = (option: { value: string; label: string }) => {
        const {value,label } = option;

        if (infoContent) {
            return (
                <Option key={value} value={value}>
                    <div className={'dropdown-custom-option'}>
                        <div className={'value'}>{label}</div>
                        <Popover content={infoContent(value)} trigger={'hover'} placement={'right'} showArrow={false}>
                            <div className={'info-icon'}>
                                <CustomIcon type={IconType.INFO} />
                            </div>
                        </Popover>
                    </div>
                </Option>
            );
        } else {
            return <Option key={value} value={value}>{label}</Option>;
        }
    };

    const popoverContent = options.filter(item => value?.includes(item.value))
        .map(item => <div key={item.value}>{item.label}</div>);

    const renderSelect = <Select
        className={'table-dropdown'}
        popupClassName={'popup-table-dropdown dropdown-custom'}
        value={value}
        placeholder={placeholder || 'Select'}
        onChange={(newValue) => editProp(accessor, newValue)}
        style={{width: '100%'}}
        {...selectProps}
        suffixIcon={<Arrow />}
        onDropdownVisibleChange={handleDropdownVisibleChange}
    >
        {options.map(renderOption)}
    </Select>;

    return <Popover open={popoverVisible} content={popoverContent} placement={'top'} overlayClassName={'max-tag-popover'}>
                {renderSelect}
            </Popover>;
};
